/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    GUEST_ACCESS_PHASE1_GUEST_CONTEXT
 * Date:         2026-07-05
 * Modified By:  Engineering
 *
 * Description:
 * Exposes whether the current visitor is an anonymous guest (no token).
 * App.tsx provides the value; Navbar / Dashboard / Search consume it to render
 * the public experience (hide personal boxes, lock tabs, use /public endpoints,
 * gate protected actions behind the AuthModal).
 */

import { createContext, useContext } from "react";

export const GuestModeContext = createContext<boolean>(false);

/** True when the visitor is browsing without a live session (guest mode). */
export const useIsGuest = (): boolean => useContext(GuestModeContext);
